// Module
var code = "<react-component name=\"UserPolicyResponses\"></react-component>\n";
// Exports
module.exports = code;